import appModule from '@/app-module';

export default {
  beforeRouteEnter(to, from, next) {
    if (!to.meta || !to.meta.emailAlreadyVerified) {
      next();
      return;
    }

    const store = appModule.storeAsync();

    store.dispatch('auth/waitUntilInit').then(() => {
      if (
        store.getters['auth/authenticated']
        && store.getters['auth/emailVerified']
      ) {
        next('/');
      } else {
        next();
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/auth/guards/email-already-verified-guard-mixin.js